import { SubscriptionPlanTitle } from '../../../../../../../../../shared/utils/subscription-plans';

export function LeadFinderSubscriptionPlansKey() {
  const leadNormalMonthlyEmailPlans = [
    'lf-starter-monthly-03-2026',
    'lf-pro-monthly-03-2026',
  ];

  const leadNormalYearlyEmailPlans = [
    'lf-starter-yearly-03-2026',
    'lf-pro-yearly-03-2026',
  ];

  return {
    leadNormal: {
      1: {
        email: leadNormalMonthlyEmailPlans,
        emailPhone: [
          'lead-finder-email-phone-starter-monthly-09-2024',
          'lead-finder-email-phone-pro-monthly-09-2024',
        ],
      },
      12: {
        email: leadNormalYearlyEmailPlans,
        emailPhone: [
          'lead-finder-email-phone-starter-yearly-09-2024',
          'lead-finder-email-phone-pro-yearly-09-2024',
        ],
      },
    },
  };
}

export const customPlanScale100kMonthly = {
  id: 92,
  amount: '11111.00',
  planName: SubscriptionPlanTitle.OutreachScaleMonthly100k,
  planCode: 'outreach-scale-plus-100k-monthly',
  currency: 'USD',
  planValidityDays: 30,
  planType: 'value-based',
  planMode: 1,
  isCustomPlan: true,
};

export const customPlanScale100kYearly = {
  id: 97,
  amount: '36.00',
  planName: SubscriptionPlanTitle.OutreachScaleYearly100k,
  planCode: 'outreach-scale-plus-100k-yearly',
  currency: 'USD',
  planValidityDays: 365,
  planType: 'value-based',
  planMode: 12,
  isCustomPlan: true,
};

export const getLeadFinderPlanData = ({
  planMode,
  basePlans,
}: {
  planMode: number;
  basePlans: any[];
}) => {
  const planKeys = LeadFinderSubscriptionPlansKey();
  const allowedPlanCodes = planKeys.leadNormal[planMode]?.email || [];

  return basePlans.filter(
    (plan) =>
      plan.planMode === planMode && allowedPlanCodes.includes(plan.planCode),
  );
};
